import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsEditResolverErrorStatesEnum {
    GetExtendedIndividualFailed = ErrorStateScheduleEnum.PanelClientsEditResolverStatesStartIndex,
    GetExtendedIndividualNotFound,
    GetCountriesFailed,
    GetCountriesInvalidData,
    GetPortalsFailed,
    GetPortalsInvalidData,
    GetExtendedCompanyFailed,
    GetExtendedCompanyNotFound,
    GetCompanyEmployeesFailed,
    GetCompanyEmployeesNoDataFound,
}
